import { render, staticRenderFns } from "./ColorLegend.vue?vue&type=template&id=60c470f9&scoped=true&"
import script from "./ColorLegend.vue?vue&type=script&lang=js&"
export * from "./ColorLegend.vue?vue&type=script&lang=js&"
import style0 from "./ColorLegend.vue?vue&type=style&index=0&id=60c470f9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c470f9",
  null
  
)

export default component.exports